import { render, staticRenderFns } from "./IntroductionSection.vue?vue&type=template&id=1652f618&scoped=true"
import script from "./IntroductionSection.vue?vue&type=script&lang=js"
export * from "./IntroductionSection.vue?vue&type=script&lang=js"
import style0 from "./IntroductionSection.vue?vue&type=style&index=0&id=1652f618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652f618",
  null
  
)

export default component.exports